export default __webpack_public_path__ + "static/media/credit_card_icon.cf3ecb2c.svg";